/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locales_Fr_FrInputs */

const en_us2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const pt_br2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const es_419_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const pt_pt2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const fr_fr2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const de_de2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const it_it2_locales_fr_fr = /** @type {(inputs: Locales_Fr_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

/**
* | output |
* | --- |
* | "Français" |
*
* @param {Locales_Fr_FrInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const locales_fr_fr = /** @type {((inputs?: Locales_Fr_FrInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locales_Fr_FrInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_locales_fr_fr(inputs)
	if (locale === "es-419") return es_419_locales_fr_fr(inputs)
	if (locale === "pt-PT") return pt_pt2_locales_fr_fr(inputs)
	if (locale === "fr-FR") return fr_fr2_locales_fr_fr(inputs)
	if (locale === "de-DE") return de_de2_locales_fr_fr(inputs)
	if (locale === "it-IT") return it_it2_locales_fr_fr(inputs)
	return en_us2_locales_fr_fr(inputs)
});
export { locales_fr_fr as "locales.fr_fr" }